import axiosInstance from "services/AxiosInstance";
import { ResponseType, TImportTransactionMeta } from "types";

export const getImportTransactionMetaService = async (
  importId: string
): Promise<ResponseType<{ columns: TImportTransactionMeta[] }>> => {
  const response = await axiosInstance.get(`imports/${importId}/transaction-meta`);
  return response.data;
};
